import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingWhatWillILookLikeWhenImOlderConfig } from '@/data/landingConfig/landingWhatWillILookLikeWhenImOlderConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_WhatWillILookLikeWhenImOlder } from './schemaObject';

interface Props {}
const WhatWillILookLikeWhenImOlder: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_WhatWillILookLikeWhenImOlder} />
			<LandingTemplate
				data={landingWhatWillILookLikeWhenImOlderConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAgeProgression()}
			/>
		</>
	);
};

export default WhatWillILookLikeWhenImOlder;
